import { Style } from 'index';

const DynamicInputDisplayStyles: Style = {
    dynamicInputSection: {
        marginY: '0.5rem',
    },
    valuesListContainer: {
        display: 'block',
        borderCollapse: 'separate',
        borderSpacing: '20px 0px',
        marginLeft: '-20px',
    },
    tr: {
        display: 'table-row',
    },
    cell: {
        display: 'table-cell',
    },
};

export default DynamicInputDisplayStyles;
